// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qCm_j","rightAdornment":"Header_rightAdornment__3Z84D"};